import { useState } from 'react';
import { Container, Grid, TextField, MenuItem } from '@mui/material';
import { fetchMyPortfolio } from '../../lib/api';
import { navigate } from '../../lib/navigation';
import { useOwnedSection } from '../../lib/useOwnedSection';
import Button from '../../components/Button';
import PageHeader from '../../components/PageHeader';
import SectionLoading from '../../components/SectionLoading';
import PortfolioCard from './PortfolioCard';
import EmptyState from '../../components/EmptyState';

function PortfolioPage() {
  const { items: portfolio, loading } = useOwnedSection(fetchMyPortfolio, '/v1/profiles/me/portfolio', (next) => ({ portfolio: next }));
  const [filter, setFilter] = useState('All');

  if (loading) return <SectionLoading />;

  const visible = portfolio.filter((item) => filter === 'All' || item.type === filter || item.platform === filter);
  const filterOptions = ['All', 'TikTok', 'Instagram', 'Short-form video', 'UGC sample', 'Case study'];
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <PageHeader
        title="Content samples"
        description="Show brands your creativity and the kind of content you can make for them — this is often what seals your first paid partnership."
        action={<Button onClick={() => navigate('/dashboard/portfolio/new')}>Add content sample</Button>}
      />
      {portfolio.length === 0 ? (
        <EmptyState
          title="No content samples yet"
          text="Add work that shows brands what you create. This is optional for publishing, but it makes your profile much stronger."
          action={<Button onClick={() => navigate('/dashboard/portfolio/new')}>Add your first content sample</Button>}
        />
      ) : (
        <>
          <TextField
            select
            size="small"
            label="Filter"
            value={filter}
            onChange={(event) => setFilter(event.target.value)}
            sx={{ mb: 3, minWidth: 220 }}
          >
            {filterOptions.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </TextField>
          <Grid container spacing={3}>
            {visible.map((item) => (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={item.id}>
                <PortfolioCard item={item} />
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Container>
  );
}

export default PortfolioPage;
